import { useState } from 'react';
import { Plane, Hotel, MapPin, X } from 'lucide-react';
import FlightSearch from './FlightSearch';
import HotelSearch from './HotelSearch';
import ActivitiesSearch from './ActivitiesSearch';

interface SearchPanelProps {
  tripId: string;
  destination?: string;
  onClose?: () => void;
  onSelectItem?: (item: any, type: string) => void;
}

export default function SearchPanel({ tripId, destination, onClose, onSelectItem }: SearchPanelProps) {
  const [activeTab, setActiveTab] = useState<'flights' | 'hotels' | 'activities'>('flights');

  const tabs = [
    { id: 'flights' as const, label: 'Flights', icon: Plane },
    { id: 'hotels' as const, label: 'Hotels', icon: Hotel },
    { id: 'activities' as const, label: 'Activities', icon: MapPin },
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-100">
        <div className="flex items-center gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                activeTab === tab.id
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <tab.icon className="h-4 w-4" />
              {tab.label}
            </button>
          ))}
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-200 rounded-lg transition"
          >
            <X className="h-5 w-5 text-gray-500" />
          </button>
        )}
      </div>

      {/* Content */}
      <div className="p-4">
        {activeTab === 'flights' && (
          <FlightSearch
            onSelectFlight={(flight) => onSelectItem?.(flight, 'flight')}
          />
        )}
        {activeTab === 'hotels' && (
          <HotelSearch
            initialCity={destination}
            onSelectHotel={(hotel) => onSelectItem?.(hotel, 'hotel')}
          />
        )}
        {activeTab === 'activities' && (
          <ActivitiesSearch
            onSelectActivity={(activity) => onSelectItem?.(activity, 'activity')}
          />
        )}
      </div>
    </div>
  );
}
